import { render, staticRenderFns } from "./AdminCreateUserDialog.vue?vue&type=template&id=52979d48&"
import script from "./AdminCreateUserDialog.vue?vue&type=script&lang=ts&"
export * from "./AdminCreateUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports